const STORAGE_KEY = 'crm_dashboard_modelos';

function loadFromStorage() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (_e) {
    return [];
  }
}

function saveToStorage(modelos) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(modelos));
}

export const state = {
  modelosSalvos: loadFromStorage(),
  visaoAtual: 'grid',
  filtrosRotulos: [],
};

export const mutations = {
  SET_MODELOS(state, modelos) {
    state.modelosSalvos = modelos;
    saveToStorage(modelos);
  },
  ADD_MODELO(state, modelo) {
    state.modelosSalvos.push(modelo);
    saveToStorage(state.modelosSalvos);
  },
  REMOVE_MODELO(state, id) {
    state.modelosSalvos = state.modelosSalvos.filter(m => m.id !== id);
    saveToStorage(state.modelosSalvos);
  },
  SET_VISAO(state, visao) {
    state.visaoAtual = visao;
  },
  SET_FILTROS_ROTULOS(state, filtros) {
    state.filtrosRotulos = filtros;
  },
};

export const getters = {
  modelosSalvos: (state) => state.modelosSalvos,
  visaoAtual: (state) => state.visaoAtual,
  filtrosRotulos: (state) => state.filtrosRotulos,
};

export const actions = {
  salvarModelo({ commit }, modelo) {
    commit('ADD_MODELO', modelo);
  },
  removerModelo({ commit }, id) {
    commit('REMOVE_MODELO', id);
  },
  setVisao({ commit }, visao) {
    commit('SET_VISAO', visao);
  },
  setFiltrosRotulos({ commit }, filtros) {
    commit('SET_FILTROS_ROTULOS', filtros);
  },
  aplicarModelo({ commit }, modelo) {
    commit('SET_VISAO', modelo.visao_padrao || modelo.visaoPadrao || 'grid');
    commit('SET_FILTROS_ROTULOS', modelo.filtros_rotulos || modelo.filtrosRotulos || []);
  },
};
